var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner-registration"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"wireframe"}),_c('div',{staticClass:"cont"},[_c('span',{staticClass:"text"},[_vm._v("现在订购，马上开启自己的电商业务")]),_c('button',{staticClass:"btn",on:{"click":_vm.onClick}},[_vm._v("立即订购")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }